export default {
	accordions: {
		grade1: {
			description:
				'A vehicle in excellent condition that may have negligible cosmetic damage (e.g. a vehicle with 2 small scratches)',
		},
		grade2: {
			description:
				'A vehicle in great condition that may contain Grade 1 damages, with an additional number of low volume minor damages (e.g. a vehicle with 1 medium scratch and 2 medium dents)',
		},
		grade3: {
			description:
				'A vehicle in good condition that may contain Grade 1 & 2 damages, as well as more noticeable moderate damages (e.g. a vehicle with 2 medium scratches, 1 small dent and 2 medium paintwork problems)',
		},
		grade4: {
			description:
				'A vehicle in average condition that may contain Grade 1, 2 & 3 damages, as well as multiple additional moderate damages (e.g. a vehicle with 2 medium dents, 2 medium paintwork problems, 4 damaged alloys and 4 medium scratches)',
		},
		grade5: {
			description:
				'A vehicle in below average condition that may contain Grade 1, 2, 3 & 4 damages, with additional signs of excessive wear and tear with numerous major damages (e.g. a vehicle with 5 medium scratches, 3 medium dents, 1 large paintwork problem)',
		},
	},
	footer: {
		buttons: {
			no: 'No',
			yes: 'Yes',
		},
		description: 'This is a new feature - your feedback will help us improve its accuracy.',
		negativeFeedbackForm: {
			checkboxes: {
				criteriaWrong: 'Grading criteria is wrong',
				doesNotReflectCondition: 'Grading does not reflect vehicle condition',
				notAccurate: 'Vehicle not accurately profiled',
				somethingElse: 'Something else',
			},
			checkboxPrompt: `Let us know why this wasn't helpful`,
			freeTextPlaceholder: 'Add details here',
			freeTextPrompt: `Let us know why this wasn't helpful`,
			submit: 'Submit feedback',
		},
		question: 'Is the updated grading format helpful?',
	},
	header: {
		description:
			'Vehicles are scored based on various damage types declared by the seller including scratches and scuffs, dents, paintwork problems, alloy damage and windscreen chips.',
		heading: 'Exterior grading',
	},
	toast: {
		content: `We'll use your feedback to help improve this feature.`,
		heading: 'Feedback submitted',
	},
};
